import { render, staticRenderFns } from "./sidebar-layout.vue?vue&type=template&id=96251aba"
import script from "./sidebar-layout.vue?vue&type=script&lang=js"
export * from "./sidebar-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96251aba')) {
      api.createRecord('96251aba', component.options)
    } else {
      api.reload('96251aba', component.options)
    }
    module.hot.accept("./sidebar-layout.vue?vue&type=template&id=96251aba", function () {
      api.rerender('96251aba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/main/layouts/sidebar-layout.vue"
export default component.exports